import {
  Card,
  CardContent,
  FormControlLabel,
  Radio,
  RadioGroup,
  Button,
} from "@material-ui/core";

import React, { Component } from "react";
import { Alert } from "react-bootstrap";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { SUBSCRIPTION_INTERVAL } from "../../../Communication/Constants";
import { PATHS } from "../../../Constants";
import "./PlansCheckout.scss";

class PlansCheckout extends Component {
  constructor(props) {
    super(props);
    this.state = { paymentTerm:"Monthly", yearlyPlan:"", monthlyPlan:"", transactionInfo: "", errorCase:false, errorMessage:""}
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount = () => {
    // console.log(this.props);
    this.setupData()
  }

  componentDidUpdate = () => {
      // console.log('updated state',this.state);
  }

  setupData = () => {
    let plansArray = [];
    let transactionInfo = {transactionId:"", transactionCreatedAt:"", paymentNeeded:"", autoRenewal:""};
    let monthlyPlan = {};
    let yearlyPlan = {};
    let monthlyPlanName = "";
    let yearlyPlanName = "";
    let productName = "";
    if (this.props.createTransactionResponse) {
      this.props.createTransactionResponse.data.forEach((response)=>{
        plansArray = response.plans;
        transactionInfo.transactionId = response.transaction_id;
        transactionInfo.transactionCreatedAt = response.transaction_created_at;
        transactionInfo.paymentNeeded = response.payment_needed;
        transactionInfo.autoRenewal = response.auto_renewal;
      });

      plansArray.map((plan) => {
        if(plan.interval === SUBSCRIPTION_INTERVAL.MONTHLY && plan.plan_name.includes('Monthly Price')) {
          monthlyPlan = plan
          monthlyPlanName = plan.plan_name;
          productName = monthlyPlanName.split('Monthly Price')[0];
        }

        if(plan.interval === SUBSCRIPTION_INTERVAL.ANNUAL && plan.plan_name.includes('Yearly Price')) {
          yearlyPlan = plan
          yearlyPlanName = plan.plan_name;
          productName = yearlyPlanName.split('Yearly Price')[0];
        }
      });


      /* if (monthlyPlanName.split("Monthly Price")[0] === yearlyPlanName.split("Yearly Price")[0]) {
        console.log('MonthlyPrice Split', monthlyPlan.split('Monthly Price')[0]);
          productName = monthlyPlanName.split('Monthly Price')[0];
      } */
      this.setState({ yearlyPlan: yearlyPlan, monthlyPlan: monthlyPlan, transactionInfo: transactionInfo, productName: productName});
    }
    else {
      this.setState({ errorCase: true, errorMessage: "Failure during transaction. Please try again!"});
    }
  }

  handleChange = (event) => {
      this.setState({ paymentTerm: event.target.value });
  }

  handleSubmit = () => {
    let selectedPlanInfo = null;
    if (this.state.paymentTerm === "Yearly"){
      selectedPlanInfo = this.state.yearlyPlan;
    }
    else {
      selectedPlanInfo = this.state.monthlyPlan;
    }
    let purchaseSummary = {
      selectedPlanInfo: selectedPlanInfo,
      transactionInfo: this.state.transactionInfo,
    }
    localStorage.setItem("purchaseSummary", JSON.stringify(purchaseSummary));
    this.props.history.push({ pathname:PATHS.PLANS + PATHS.PURCHASE_SUMMARY });
  }

  renderAlert = () => {
    return (
      <Alert variant="danger" className="alertMessage">
        {this.state.errorMessage}
      </Alert>
    );
  };

  renderErrorUI = () => {
    return (
      <div className="errorContainer">
          {this.renderAlert()}
        </div>
    );
  };

  renderMainUI = () => {
    return (
    <>
<div className="plansCheckoutContainer">
          <div className="planSectionContainer">
            <div className="planInfoTableContainer">
              <div className="selectTermLabel">Selected Plan</div>
              <table>
                <thead>
                  <tr>
                    <th>Current Plan</th>
                    <th>New Plan</th>
                    <th>Price / month</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Free</td>
                    <td>{this.state.productName}</td>
                    <td>{this.state.paymentTerm === 'Yearly' ? `${this.state.yearlyPlan.currency_symbol}${this.state.yearlyPlan.total_amount}`: `${this.state.monthlyPlan.currency_symbol}${this.state.monthlyPlan.total_amount}`}</td>
                  </tr>
                </tbody>
              </table>

              <div className="selectTermLabel">Select Term</div>
              <>
                <Card className="SelectTermContainer">
                  <div className="RadioBtnContainer row">
                    <div className="col">
                      <RadioGroup
                        className="radioBtnGroup"
                        defaultValue="Basic"
                        name="select-term-radio-group"
                      >
                        <FormControlLabel
                          value="Yearly"
                          disabled={false}
                          className="radioBtnLabel"
                          control={<Radio onChange={this.handleChange} />}
                          label="Pay Yearly"
                          checked={this.state.paymentTerm === "Yearly" && true}
                        />
                        <FormControlLabel
                          value="Monthly"
                          disabled={false}
                          className="radioBtnLabel"
                          control={<Radio onChange={this.handleChange}/>}
                          label="Pay Monthly"
                          checked={this.state.paymentTerm === "Monthly" && true}
                        />
                      </RadioGroup>
                    </div>
                    <div className="col">
                      <CardContent className="planPrice">{`${this.state.yearlyPlan.currency_symbol}${this.state.yearlyPlan.total_amount}`}</CardContent>
                      <CardContent className="planPrice">{`${this.state.monthlyPlan.currency_symbol}${this.state.monthlyPlan.total_amount}`}</CardContent>
                    </div>
                  </div>
                </Card>
              </>
              <>
                <div className="btnWrapper">
                  <Button
                    className="checkoutBtn"
                    onClick={this.handleSubmit}
                  >
                    {"Checkout and Pay"}
                  </Button>
                </div>
              </>
            </div>
          </div>
        </div>
    </>
    )
  }

  

  render() {
    return (
      <>
        {this.state.errorCase ? this.renderErrorUI() : this.renderMainUI() }
      </>
    );
  }
}


function mapStateToProps(state) {
  return {
    userAccessTokenInfo: state.UpgradeHandler.userAccessTokenInfo,
    createTransactionResponse: state.Plans.createTransactionResponse,
  };
}


export default withRouter(
  connect(mapStateToProps)(PlansCheckout)
);
